export const formatToUSD = (value: string) => {
  const dollarUs = Intl.NumberFormat("en-US");
  return dollarUs.format(Number(value));
};
